import styled from '@emotion/styled'
import Loader from '../Loader'

import { fontWeight } from '../../helpers/styleVariables'

export const StyledText = styled.p`
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
  font-weight: ${fontWeight.bold};
  color: var(--java);
`

export const StyledLoader = styled(Loader)`
  margin-top: 10px;
`

export const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
